import { Popover as MuiPopover } from '@mui/material';
import React from 'react';

import { MenuPaper } from '@/shared/components/ui/paper/menu-paper/menu-paper';
import {
  DEFAULT_ANCHOR_ORIGIN,
  DEFAULT_TRANSFORM_ORIGIN,
} from '@/shared/components/ui/popover/components/popover/popover.const';

import { TPopoverProps, TPopoverSlotPropsPaperProps } from './popover.types';

export const Popover: React.FC<TPopoverProps> = ({
  anchorOrigin,
  transformOrigin,
  triggerRef,
  matchTriggerWidth,
  ...props
}) => {
  const getPaperStyle = () => {
    const triggerWidth = triggerRef?.current?.getBoundingClientRect()?.width;
    if (!matchTriggerWidth || !triggerWidth) {
      return;
    }
    return {
      width: triggerWidth,
    };
  };

  return (
    <MuiPopover
      slots={{
        paper: MenuPaper,
      }}
      slotProps={{
        paper: {
          $anchorOrigin: anchorOrigin,
          $transformOrigin: transformOrigin,
          style: getPaperStyle(),
        } as TPopoverSlotPropsPaperProps,
      }}
      anchorOrigin={anchorOrigin || DEFAULT_ANCHOR_ORIGIN}
      transformOrigin={transformOrigin || DEFAULT_TRANSFORM_ORIGIN}
      {...props}
    />
  );
};
